module.exports = __webpack_public_path__ + "static/media/rekit-logo.7480cbd9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/rekit-logo.svg
// module id = 98
// module chunks = 0